import { useDisclosure } from '@mantine/hooks'
import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import Dialog from '~/features/chatbot/components/dialog'
import Header from '~/features/chatbot/components/linkView/header'
import Intro from '~/features/chatbot/components/linkView/intro'
import {
  EMBEDDED_CHAT_KEY,
  EMBEDDED_CHAT_VALUE,
} from '~/features/chatbot/constants'
import { EChatbotTheme } from '~/features/settings/models'
import { store } from '~/store'

function LinkView() {
  const location = useLocation()
  const isEmbedded =
    new URLSearchParams(location.search).get(EMBEDDED_CHAT_KEY) ===
    EMBEDDED_CHAT_VALUE

  const [isChatting, { toggle }] = useDisclosure(false)
  const chatbotLayout = store((state) => state.chatbot.layout)
  useEffect(() => {
    if (isEmbedded && !isChatting) {
      toggle()
    }
  }, [isEmbedded, isChatting, toggle])

  return (
    <Stack
      sx={{
        height: '100%',
        flexDirection: 'column',
        width: '100%',
        backgroundColor:
          chatbotLayout.options[EChatbotTheme.linkView][
            chatbotLayout.selection[EChatbotTheme.linkView]
          ].mainBackgroundColor,
      }}
    >
      <Header
        isChatting={isChatting}
        toggleChatHandler={toggle}
        hideToggleChat={isEmbedded}
      />
      {isChatting ? <Dialog /> : <Intro chatNowHandler={toggle} />}
    </Stack>
  )
}

export default LinkView
